import PropTypes from 'prop-types';

export const TeamMemberServiceVariationPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  itemVariation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // id
  priceOverride: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  priceDisplayOverride: PropTypes.string,
});
